// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"6d75c499","814":"83d16ec4"}[chunkId] + ".chunk.css";
};